// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'    // element-ui主题
import 'element-ui/lib/theme-chalk/display.css' // 基于断点的隐藏类
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
//引入公共样式
import '../src/assets/css/common.css'
// 响应式布局样式
import '../src/assets/css/response.css'


import OrganizationAside from '@/components/OrganizationAside.vue'
import MemberAside from '@/components/MemberAside.vue'
import LiteratureAside from '@/components/LiteratureAside.vue'
import DynamicAside from '@/components/DynamicAside.vue'

import router from './router'

// js
import ChinaCity from './assets/js/ChinaCity.js'
Vue.prototype.ChinaCity = ChinaCity



// 全局引入echarts
import echarts from 'echarts';
Vue.prototype.$echarts=echarts;

import $ from 'jquery';
Vue.prototype.$=$;

Vue.use(Header,Footer,OrganizationAside,MemberAside,LiteratureAside);
Vue.component('Header', Header);
Vue.component('Footer',Footer);
Vue.component('OrganizationAside',OrganizationAside);
Vue.component('MemberAside',MemberAside);
Vue.component('LiteratureAside',LiteratureAside);
Vue.component('DynamicAside',DynamicAside);


import axios from 'axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(ElementUI,{size:'small',zIndex:3000});

// js脚本
import instance from './assets/js/http.js'
Vue.prototype.instance = instance;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
     App,
     Header
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js